import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ipn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO =
  "https://customer-assets.emergentagent.com/job_ipnomics-hub/artifacts/rde2m5da_WhatsApp%20Image%202026-07-14%20at%2012.17.30.jpeg";

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  prashant:
    "https://customer-assets.emergentagent.com/job_ipnomics-hub/artifacts/7njth1pi_ChatGPT%20Image%20Jul%2014%2C%202026%2C%2001_29_25%20PM.png",
  vikas:
    "https://customer-assets.emergentagent.com/job_ipnomics-hub/artifacts/0og0c1v6_ChatGPT%20Image%20Jul%2014%2C%202026%2C%2001_40_24%20PM.png",
  document: "https://images.unsplash.com/photo-1636797581198-1bb1f2d961b3?w=1200&q=85",
  office: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&w=1400",
};

export const COMPANY = {
  name: "IPNOMICS LLP",
  address: "Plot No. 20, Block H-1/A, Sector-63, Noida",
  region: "Uttar Pradesh — 201301, India",
  email: "enquiry@ipnomics.in",
  website: "www.ipnomics.in",
  whatsapp: "919990006529",
  mapEmbed:
    "https://www.google.com/maps?q=H-1%2FA%20Sector%2063%20Noida%20Uttar%20Pradesh%20201301&output=embed",
};

export const SERVICES = [
  {
    id: "audit-valuation",
    title: "IP Audit & Valuation",
    tag: "Flagship Practice",
    desc: "Systematic review and defensible monetary valuation of your intangible assets — cost, market, and income approaches for M&A, licensing, litigation, and fundraising.",
    star: true,
  },
  {
    id: "portfolio",
    title: "IP Portfolio Management",
    tag: "Strategy",
    desc: "End-to-end lifecycle management of your rights — docketing, renewals, prosecution, and strategic pruning to maximise value.",
  },
  {
    id: "trademarks",
    title: "Trademark Registration",
    tag: "Protection",
    desc: "Clearance search, filing, prosecution, opposition, and renewal across all classes under the Trade Marks Act.",
  },
  {
    id: "litigation",
    title: "IP Litigation",
    tag: "Enforcement",
    desc: "Assertive enforcement and defence — infringement, passing off, oppositions, and dispute resolution before courts and tribunals.",
  },
  {
    id: "patents",
    title: "Patents",
    tag: "Innovation",
    desc: "Patentability searches, drafting, filing, and prosecution to secure exclusive rights over your inventions.",
  },
  {
    id: "designs",
    title: "Industrial Designs",
    tag: "Aesthetics",
    desc: "Protection for the visual design of products — shape, configuration, pattern, and ornamentation.",
  },
];

export const TEAM = [
  {
    name: "Prashant Gupta",
    role: "Founding Partner — Valuation, Finance & Audit",
    image: IMAGES.prashant,
    pos: "50% 0%",
    bio: "B.Tech (Mechanical) and an MBA in Finance, Prashant brings 17 years of experience across investment management, compliance, financial valuation, and audit. He leads IPNOMICS' IP valuation and audit practice, translating intangible assets into defensible balance-sheet value.",
  },
  {
    name: "Vikas Tiwari",
    role: "Partner — IP Litigation & Prosecution",
    image: IMAGES.vikas,
    pos: "50% 42%",
    bio: "Vikas heads the firm's contentious and prosecution practice, representing clients across trademark, patent, and copyright disputes.",
  },
];
